import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import queryString from "query-string";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { init, update } from "../../redux/actions/planningSheet";
import React, { useEffect } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import "../css/PlaningSheet.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { print, PRINTING_RESET } from "../../redux/actions/printing";

export default function PlaningSheet() {
  const { handleSubmit } = useForm();
  const [newApproachWhen1, setNewApproachWhen1] = useState("");
  const [newApproachHow1, setNewApproachHow1] = useState("");
  const [newApproachWhen2, setNewApproachWhen2] = useState("");
  const [newApproachHow2, setNewApproachHow2] = useState("");
  const [newApproachWhen3, setNewApproachWhen3] = useState("");
  const [newApproachHow3, setNewApproachHow3] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedGrade2, setSelectedGrade2] = useState("");
  const [selectedGrade3, setSelectedGrade3] = useState("");
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const user = useSelector(state => state.auth.user);
  const planningSheet = useSelector(state => state.planningSheet);
  const priorityTargets = useSelector(state => state.planningSheet.priorityTargets);
  const downloadLink = useSelector(state => state.printing.downloadLink);
  const planningSheetMessage = useSelector(state => state.planningSheet.message);
  const gradeRange = useSelector(state => state.planningSheet.gradeRange);
  const dispatch = useDispatch();
  const termId = searchParams.get("termId");
  const listId = searchParams.get("listId");

  useEffect(
    () => {
      const currentUrl = window.location.href;

      const parsedUrl = queryString.parseUrl(currentUrl);

      const { termId, listId } = parsedUrl.query;
      const params = { termId: termId, listId: listId };

      dispatch(init(params));
    },
    [dispatch]
  );

  useEffect(
    () => {
      if (priorityTargets) {
        setNewApproachWhen1(priorityTargets.length > 0 ? priorityTargets[0].approachScene : null);
        setNewApproachWhen2(priorityTargets.length > 1 ? priorityTargets[1].approachScene : null);
        setNewApproachWhen3(priorityTargets.length > 2 ? priorityTargets[2].approachScene : null);
        setNewApproachHow1(priorityTargets.length > 0 ? priorityTargets[0].howToApproach : null);
        setNewApproachHow2(priorityTargets.length > 1 ? priorityTargets[1].howToApproach : null);
        setNewApproachHow3(priorityTargets.length > 2 ? priorityTargets[2].howToApproach : null);
        setSelectedGrade(priorityTargets.length > 0 ? priorityTargets[0].targetGrading : null);
        setSelectedGrade2(priorityTargets.length > 1 ? priorityTargets[1].targetGrading : null);
        setSelectedGrade3(priorityTargets.length > 2 ? priorityTargets[2].targetGrading : null);
      }
    },
    [priorityTargets]
  );

  useEffect(
    () => {
      if (downloadLink) {
        window.open(`/neqst${downloadLink}`, "_blank");
        dispatch({ type: PRINTING_RESET });
      }
    },
    [downloadLink]
  );

  useEffect(
    () => {
      if (planningSheetMessage) {
        setMessage(planningSheetMessage);
      }
    },
    [planningSheetMessage]
  );

  const handleGradeChange = event => {
    setSelectedGrade(event.target.value);
  };
  const handleGradeChange02 = event => {
    setSelectedGrade2(event.target.value);
  };
  const handleGradeChange03 = event => {
    setSelectedGrade3(event.target.value);
  };

  const gradeImages1 = {
    "01":
      planningSheet.stickerList.length > 0 ? `/neqst/images/${listId}/${planningSheet.stickerList[0].fileName}` : null,
    "02":
      planningSheet.stickerList.length > 1 ? `/neqst/images/${listId}/${planningSheet.stickerList[1].fileName}` : null,
    "03":
      planningSheet.stickerList.length > 2 ? `/neqst/images/${listId}/${planningSheet.stickerList[2].fileName}` : null,
    "04":
      planningSheet.stickerList.length > 3 ? `/neqst/images/${listId}/${planningSheet.stickerList[3].fileName}` : null,
    "05":
      planningSheet.stickerList.length > 4 ? `/neqst/images/${listId}/${planningSheet.stickerList[4].fileName}` : null,
    "06":
      planningSheet.stickerList.length > 5 ? `/neqst/images/${listId}/${planningSheet.stickerList[5].fileName}` : null
  };
  const gradeImages2 = {
    "01":
      planningSheet.stickerList.length > 6 ? `/neqst/images/${listId}/${planningSheet.stickerList[6].fileName}` : null,
    "02":
      planningSheet.stickerList.length > 7 ? `/neqst/images/${listId}/${planningSheet.stickerList[7].fileName}` : null,
    "03":
      planningSheet.stickerList.length > 8 ? `/neqst/images/${listId}/${planningSheet.stickerList[8].fileName}` : null,
    "04":
      planningSheet.stickerList.length > 9 ? `/neqst/images/${listId}/${planningSheet.stickerList[9].fileName}` : null,
    "05":
      planningSheet.stickerList.length > 10 ? `/neqst/images/${listId}/${planningSheet.stickerList[10].fileName}` : null,
    "06":
      planningSheet.stickerList.length > 11 ? `/neqst/images/${listId}/${planningSheet.stickerList[11].fileName}` : null
  };
  const gradeImages3 = {
    "01":
      planningSheet.stickerList.length > 12 ? `/neqst/images/${listId}/${planningSheet.stickerList[12].fileName}` : null,
    "02":
      planningSheet.stickerList.length > 13 ? `/neqst/images/${listId}/${planningSheet.stickerList[13].fileName}` : null,
    "03":
      planningSheet.stickerList.length > 14 ? `/neqst/images/${listId}/${planningSheet.stickerList[14].fileName}` : null,
    "04":
      planningSheet.stickerList.length > 15 ? `/neqst/images/${listId}/${planningSheet.stickerList[15].fileName}` : null,
    "05":
      planningSheet.stickerList.length > 16 ? `/neqst/images/${listId}/${planningSheet.stickerList[16].fileName}` : null,
    "06":
      planningSheet.stickerList.length > 17 ? `/neqst/images/${listId}/${planningSheet.stickerList[17].fileName}` : null
  };
  const gradeText = {
    "01": "S",
    "02": "A",
    "03": "B",
    "04": "C",
    "05": "D",
    "06": "E"
  };
  const selectedImage = gradeImages1[selectedGrade];
  const selectedImage2 = gradeImages2[selectedGrade2];
  const selectedImage3 = gradeImages3[selectedGrade3];
  const defaultImage1 = gradeImages1[selectedGrade];
  const defaultImage2 = gradeImages2[selectedGrade2];
  const defaultImage3 = gradeImages3[selectedGrade3];
  const currentGrade01 = planningSheet.priorityTargets.length > 0 ? planningSheet.priorityTargets[0].currentGrading : null;
  const currentGrade02 = planningSheet.priorityTargets.length > 1 ? planningSheet.priorityTargets[1].currentGrading : null;
  const currentGrade03 = planningSheet.priorityTargets.length > 2 ? planningSheet.priorityTargets[2].currentGrading : null;

  const grades = gradeRange
    ? Array.from({ length: gradeRange.end - gradeRange.start + 1 }, (_, i) => {
        const gradeNum = gradeRange.start + i;
        const value = String(gradeNum).padStart(2, "0");
        const label = ["S", "A", "B", "C", "D", "E"][gradeNum - 1];
        return { value, label };
      }).filter(grade => grade.label)
    : [
        { value: "01", label: "S" },
        { value: "02", label: "A" },
        { value: "03", label: "B" },
        { value: "04", label: "C" },
        { value: "05", label: "D" },
        { value: "06", label: "E" }
      ];

  const handleUpdateSubmit = params => {
    if (priorityTargets) {
      console.log(params);
      const text = [
        { planingWhen: newApproachWhen1, planingHow: newApproachHow1 },
        { planingWhen: newApproachWhen2, planingHow: newApproachHow2 },
        { planingWhen: newApproachWhen3, planingHow: newApproachHow3 }
      ];
      const grading = [selectedGrade, selectedGrade2, selectedGrade3];
      const currentGrading = [currentGrade01, currentGrade02, currentGrade03];
      const itemId = planningSheet.priorityTargets.map(target => target.itemId);
      const rows = [];
      for (let index = 0; index < planningSheet.priorityTargets.length; index++) {
        const textData = text[index] || {};
        rows.push({
          serialNumber: planningSheet.serialNumber,
          grade: planningSheet.grade,
          classNumber: planningSheet.classNumber,
          number: planningSheet.number,
          name: planningSheet.name,
          termId: termId,
          listId: listId,
          itemId: itemId[index],
          currentGrading: currentGrading[index],
          targetGrading: grading[index],
          approachScene: textData.planingWhen || "",
          howToApproach: textData.planingHow || ""
        });
      }
      dispatch(update({ listId, termId, rows }));
    }
  };

  const handleSelfEvaluationButton = () => {
    window.location.href = `/Evaluation?listId=${listId}&termId=${termId}`;
  };

  const handleOtherEvaluationButton = () => {
    window.location.href = `/Evaluation?isOther=${true}&listId=${listId}&termId=${termId}`;
  };

  const handleEvaluationComparisonButton = () => {
    window.location.href = `/EvaluationComparison?listId=${listId}&termId=${termId}`;
  };

  const handlePrintButton = () => {
    const request = {
      printTarget: 4,
      listId,
      termId,
      students: [
        {
          serialNumber: user.student.serialNumber,
          grade: user.student.grade
        }
      ]
    };
    dispatch(print(request));
  };

  const navigate = useNavigate();
  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <Box>
      <Header />
      <Container>
        <Grid container spacing={2}>
          <FormControl fullWidth sx={{ ml: 9, mt: 4 }}>
            <Typography component="h5" variant="h6" align="left">
              目標設定シート【{planningSheet.subTitle}】 {planningSheet.grade}年{planningSheet.classNumber}組 {planningSheet.name}
            </Typography>
          </FormControl>
          <Grid item xs={9}>
            <div className="container2" style={{ backgroundColor: "#7F7F7F" }}>
              <div className="div-plan-1" style={{ height: "40px" }}>
                <Typography component="h5" variant="h7" color="white">
                  NO.
                </Typography>
              </div>
              <div className="div-plan-2" style={{ height: "40px" }}>
                <Typography component="h5" variant="h7" color="white">
                  こうもく
                </Typography>
                <Typography component="h5" variant="h7" color="white">
                  項目
                </Typography>
              </div>
            </div>
            <div className="container2" style={{ alignItems: "stretch" }}>
              <div className="div-plan-4" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  いまのじぶん
                </Typography>
              </div>
              <div className="div-plan-4" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  なりたいすがた
                </Typography>
              </div>
              <div className="div-plan-3" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  【さくせん】どのばめんでとりくむ？
                </Typography>
              </div>
              <div className="div-plan-3" style={{ height: "auto" }}>
                <Typography variant="h7" fontSize={10}>
                  【さくせん】どのようにとりくむ？
                </Typography>
              </div>
            </div>
            <div className="container2" style={{ alignItems: "stretch" }}>
              <div className="div-plan-4" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  今の自分
                </Typography>
              </div>
              <div className="div-plan-4" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  なりたい姿
                </Typography>
              </div>
              <div className="div-plan-3" style={{ height: "auto" }}>
                <Typography fontSize={10} variant="h7">
                  【作戦】どの場面で取り組む？
                </Typography>
              </div>
              <div className="div-plan-3" style={{ height: "auto" }}>
                <Typography variant="h7" fontSize={10}>
                  【作戦】どのように取り組む？
                </Typography>
              </div>
            </div>
            <div className="container2" style={{ backgroundColor: "#7F7F7F" }}>
              <div className="div-plan-7" style={{ height: "20px" }}>
                <Typography component="h5" variant="h7" color="white">
                  {planningSheet.targetSettings.length > 0 ? planningSheet.targetSettings[0].item : ""}
                </Typography>
              </div>
            </div>
            <div className="container2">
              <div className="div-plan-5" style={{ height: "150px" }}>
                <p>{gradeText[currentGrade01]}</p>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {planningSheet.targetSettings.length > 0 && (
                  <img
                    className="card-currentgrade"
                    id="nowImageOne"
                    src={`/neqst/images/${listId}/${planningSheet.targetSettings[0].currentGrading}`}
                    alt="Grading Image"
                  />
                )}
              </div>
              <div className="div-plan-5" style={{ height: "150px" }}>
                <FormControl sx={{ minWidth: 20 }}>
                  <p style={{ marginTop: "32px" }}>{gradeText[selectedGrade]}</p>
                  <select value={selectedGrade} label="選択してください" onChange={handleGradeChange}>
                    <option value="">-</option>
                    {grades.map(grade => (
                      <option key={grade.value} value={grade.value}>
                        {grade.label}
                      </option>
                    ))}
                  </select>
                </FormControl>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {selectedImage && (
                  <img src={selectedImage} width={"114px"} height={"150px"} alt={`Grade ${selectedGrade} Image`} />
                )}
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachWhen1}
                    onChange={event => {
                      setNewApproachWhen1(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" }
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachHow1}
                    onChange={event => {
                      setNewApproachHow1(event.target.value); // newApproachWhen1 の値を更新
                    }}
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" } // ラベルの色を黒に設定
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="container2" style={{ backgroundColor: "#7F7F7F" }}>
              <div className="div-plan-7" style={{ height: "20px" }}>
                <Typography component="h5" variant="h7" color="white">
                  {planningSheet.targetSettings.length > 1 ? planningSheet.targetSettings[1].item : ""}
                </Typography>
              </div>
            </div>
            <div className="container2">
              <div className="div-plan-5" style={{ height: "150px" }}>
                <p>{gradeText[currentGrade02]}</p>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {planningSheet.targetSettings.length > 1 && (
                  <img
                    className="card-currentgrade"
                    id="nowImageOne"
                    src={`/neqst/images/${listId}/${planningSheet.targetSettings[1].currentGrading}`}
                    alt="Grading Image"
                  />
                )}
              </div>
              <div className="div-plan-5" style={{ height: "150px" }}>
                <FormControl sx={{ minWidth: 20 }}>
                  <p style={{ marginTop: "32px" }}>{gradeText[selectedGrade2]}</p>
                  <select value={selectedGrade2} label="選択してください" onChange={handleGradeChange02}>
                    <option value="">-</option>
                    {grades.map(grade => (
                      <option key={grade.value} value={grade.value}>
                        {grade.label}
                      </option>
                    ))}
                  </select>
                </FormControl>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {selectedImage2 && (
                  <img src={selectedImage2} width={"114px"} height={"150px"} alt={`Grade ${selectedGrade2} Image`} />
                )}
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachWhen2}
                    onChange={event => {
                      setNewApproachWhen2(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "black" }
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachHow2}
                    onChange={event => {
                      setNewApproachHow2(event.target.value);
                    }}
                    InputLabelProps={{
                      style: { color: "black" }
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="container2" style={{ backgroundColor: "#7F7F7F" }}>
              <div className="div-plan-7" style={{ height: "20px" }}>
                <Typography component="h5" variant="h7" color="white">
                  {planningSheet.targetSettings.length > 2 ? planningSheet.targetSettings[2].item : ""}
                </Typography>
              </div>
            </div>
            <div className="container2">
              <div className="div-plan-5" style={{ height: "150px" }}>
                <p>{gradeText[currentGrade03]}</p>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {planningSheet.targetSettings.length > 2 && (
                  <img
                    className="card-currentgrade"
                    id="nowImageOne"
                    src={`/neqst/images/${listId}/${planningSheet.targetSettings[2].currentGrading}`}
                    alt="Grading Image"
                  />
                )}
              </div>
              <div className="div-plan-5" style={{ height: "150px" }}>
                <FormControl sx={{ minWidth: 20 }}>
                  <p style={{ marginTop: "32px" }}>{gradeText[selectedGrade3]}</p>
                  <select value={selectedGrade3} label="選択してください" onChange={handleGradeChange03}>
                    <option value="">-</option>
                    {grades.map(grade => (
                      <option key={grade.value} value={grade.value}>
                        {grade.label}
                      </option>
                    ))}
                  </select>
                </FormControl>
              </div>
              <div className="div-plan-6" style={{ height: "150px" }}>
                {selectedImage3 && (
                  <img src={selectedImage3} width={"114px"} height={"150px"} alt={`Grade ${selectedGrade3} Image`} />
                )}
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachWhen3}
                    onChange={event => {
                      setNewApproachWhen3(event.target.value); // newApproachWhen1 の値を更新
                    }}
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" } // ラベルの色を黒に設定
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
              <div
                className="div-plan-3"
                style={{ height: "150px", overflow: "hidden", display: "flex", flexDirection: "column" }}
              >
                <FormControl style={{ height: "150px", width: "100%" }}>
                  <TextField
                    fullWidth
                    id="standard-basic"
                    variant="outlined"
                    multiline
                    defaultValue={newApproachHow3}
                    onChange={event => {
                      setNewApproachHow3(event.target.value); // newApproachWhen1 の値を更新
                    }}
                    InputLabelProps={{
                      style: { color: "black", borderColor: "black" } // ラベルの色を黒に設定
                    }}
                    inputProps={{
                      style: { height: "125px", overflow: "auto", resize: "vertical" }
                    }}
                  />
                </FormControl>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={3} square>
          <Box
            maxWidth="md"
            sx={{
              mt: 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "left",
              maxWidth: "78%"
            }}
          >
            <Button
              variant="contained"
              size="medium"
              onClick={handleSelfEvaluationButton}
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
            >
              自己評価（あなた自身が考えるあなた）
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handleOtherEvaluationButton}
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
            >
              他者評価を見る（ほかの人から見たあなた）
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handleEvaluationComparisonButton}
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
            >
              自己評価と他者評価の違いをチェック
            </Button>
          </Box>
        </Grid>
        <Box
          maxWidth="md"
          sx={{
            mt: 5,
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            maxWidth: "78%"
          }}
        >
          <Button
            variant="contained"
            size="medium"
            onClick={handlePrintButton}
            sx={{ bgcolor: "#82b1ff", marginRight: "auto" }}
          >
            印刷
          </Button>
          <div style={{ marginTop: "5px", marginRight: "5px" }} className="div-plan-8">
            {message}
          </div>
          <div style={{ alignItems: "rigth", marginLeft: "10px" }}>
            <Button
              variant="contained"
              size="medium"
              onClick={handleSubmit(handleUpdateSubmit)}
              sx={{ bgcolor: "#82b1ff", marginLeft: "auto", mr: "40px" }}
            >
              保存
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handleBackButton}
              sx={{ bgcolor: "#82b1ff", marginLeft: "auto", mr: "40px" }}
            >
              戻る
            </Button>
          </div>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}